'use client';
import React, { useEffect, useLayoutEffect, useRef } from 'react';

import Paper from '@/app/_components/container/Paper';
import IconGear from '@/app/_images/ico_gear.svg';
import Heading from '@/app/_components/common/heading/Heading';
import Button from '@/app/_components/common/button/Button';
import IconNext from '@/app/_images/ico_arr_nav.svg';
import FlexBox from '@/app/_components/container/FlexBox';
import styles from './Error.module.scss';
import { ROUTER_PATH } from '@/app/_contants/routerPath';

interface ErrorProps {
  reset: () => void;
  message?: string;
}

const Error = (props: ErrorProps) => {
  const { reset, message } = props;
  const refBox = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const rootElement = refBox.current?.parentElement?.parentElement as HTMLElement;
    if (rootElement) {
      setTimeout(() => {
        const computedStyle = window.getComputedStyle(rootElement);
        const paddingTop = parseInt(computedStyle.paddingTop) || 0;

        // 첫 번째 자식 요소가 있는지 확인
        const firstChildElement = rootElement.children[0] as HTMLElement;
        if (firstChildElement) {
          firstChildElement.style.minHeight = `${rootElement.clientHeight - paddingTop * 2}px`;
        }
      }, 500);
    }
  }, []);

  return (
    <Paper size="full">
      <FlexBox className={styles.box}>
        <div className={styles.inner} ref={refBox}>
          <div>
            <IconGear />
          </div>
          <Heading className={'text-primary'}>
            {message}
            {/*{error.message}*/}
          </Heading>
          <div>
            <Button tag={'a'} variants={'secondary'} href={ROUTER_PATH.MAIN}>
              <span>ホームに戻る</span>
              <IconNext />
            </Button>
          </div>
        </div>
      </FlexBox>
    </Paper>
  );
};

export default Error;
